module.exports = __webpack_public_path__ + "img/teacher-white.f37d5451.png";